export const common = {
  // Navigation
  nav_features: 'Características',
  nav_security: 'Seguridad',
  nav_community: 'Comunidad',
  nav_join: 'Únete ahora',
  nav_back_home: 'Volver al inicio',
  
  // Hero Section
  hero_title: 'FaceTrue',
  hero_subtitle: 'Red social con verificación de identidad',
  hero_description_1: 'Sin cuentas falsas. Sin acoso. Sin violencia.',
  hero_description_2: 'Sin toxicidad. Sin extremismo.',
  hero_description_3: '100% positivo - Verificado por IA.',
  
  // How It Works
  how_title: 'Cómo funciona',
  step1_title: 'Verificación facial',
  step1_desc: 'Toma una selfie → IA verifica identidad → Verificación instantánea',
  step1_badge: 'Sin cuentas falsas',
  step2_title: 'Contenido limpio',
  step2_desc: 'IA filtra contenido tóxico, fraudulento y violento 24/7',
  step2_badge: 'Filtro IA 24/7',
  step3_title: 'Comunidad global',
  step3_desc: 'Publica nacional o globalmente',
  step3_badge: 'Países del mundo',
  
  // Age-Based Content Cards
  children_label: 'Edades 5-12',
  children_title: 'Espacio infantil',
  children_feature1: 'Contenido seguro y divertido',
  children_feature2: 'Controles parentales',
  children_feature3: 'Juegos educativos',
  
  adults_label: 'Edades 18-59',
  adults_title: 'Comunidad adulta',
  adults_feature1: 'Red profesional',
  adults_feature2: 'Grupos de interés',
  adults_feature3: 'Conexiones reales',
  
  seniors_label: 'Edades 60+',
  seniors_title: 'Círculo senior',
  seniors_feature1: 'Interfaz fácil',
  seniors_feature2: 'Salud y bienestar',
  seniors_feature3: 'Conexión familiar',
  
  // Why Different
  why_title: 'Por qué elegir FaceTrue',
  why_feature1_title: '100% personas reales',
  why_feature1_desc: 'Verificación de identidad por IA, elimina cuentas falsas',
  why_feature2_title: 'Sin violencia y toxicidad',
  why_feature2_desc: 'IA filtra contenido violento, tóxico y de acoso 24/7',
  why_feature3_title: 'Sin extremismo',
  why_feature3_desc: 'Elimina todas las formas de extremismo y odio',
  why_feature4_title: '100% positivo',
  why_feature4_desc: 'Solo contenido positivo, constructivo y saludable',
  why_feature5_title: 'Seguro para todas las edades',
  why_feature5_desc: 'Clasificación inteligente de contenido, adecuado para cada edad',
  why_feature6_title: 'Sistema de advertencia de 3 banderas',
  why_feature6_desc: 'Bandera amarilla (1ª infracción) → Bandera roja (2ª infracción) → Bandera negra (3ª infracción - cuenta bloqueada)',
  why_feature7_title: 'Sistema de calificación por estrellas',
  why_feature7_desc: 'Comparte información, imágenes, videos positivos → Recibe estrellas de corazón rosa de la comunidad',
  why_feature8_title: 'Publicidad auténtica',
  why_feature8_desc: 'IA verifica la autenticidad de los anuncios. Los productos se verifican por origen antes de publicar',
  
  // Video Demo
  video_title: 'Video demo de FaceTrue',
  video_subtitle: 'Ver cómo funciona',
  video_views: 'vistas',
  video_close: 'Haz clic en X para cerrar',
  video_demo_live: 'DEMO EN VIVO',
  video_info: 'Demo simulada de FaceTrue',
  video_info_cta: 'Haz clic en Play para ver la demo',
  video_update: 'El video real se actualizará desde Veo AI',
  
  // Video Stages
  scanning_title: 'Verificando...',
  scanning_desc: 'IA está verificando identidad',
  scanning_step1: 'Rostro detectado',
  scanning_step2: 'Verificación IA',
  scanning_step3: 'Creando perfil...',
  scanning_badge: '100% Personas reales',
  
  intro_step1_title: 'Verificación exitosa',
  intro_step1_subtitle: '100% personas reales',
  intro_step2_title: 'Filtrado de contenido IA',
  intro_step2_subtitle: 'Sin toxicidad, sin violencia',
  intro_step3_title: 'Conexión global',
  intro_step3_subtitle: '119 países',
  intro_step4_title: '100% positivo',
  intro_step4_subtitle: 'Solo contenido saludable',
  intro_step5_title: 'Seguro para todas las edades',
  intro_step5_subtitle: 'Niños • Adultos • Mayores',
  
  stats_title: 'Comunidad FaceTrue',
  stats_subtitle: 'Creciendo fuerte',
  stats_users: 'Usuarios',
  stats_countries: 'Países',
  stats_posts: 'Publicaciones positivas',
  stats_badge: '100% Positivo',
  
  comparison_title: 'La diferencia',
  comparison_old: 'Redes sociales antiguas',
  comparison_old_1: 'Cuentas falsas',
  comparison_old_2: 'Contenido tóxico',
  comparison_old_3: 'Violencia',
  comparison_old_4: 'Fraude',
  comparison_new: 'FaceTrue',
  comparison_new_1: '100% personas reales',
  comparison_new_2: 'Contenido limpio',
  comparison_new_3: '100% positivo',
  comparison_new_4: 'IA segura',
  
  // CTA Section
  cta_title: 'Únete ahora',
  cta_subtitle: 'Regístrate en la versión Beta de FaceTrue',
  cta_name: 'Nombre completo',
  cta_email: 'Tu correo electrónico',
  cta_button: 'Regístrate ahora',
  cta_submitting: 'Enviando...',
  cta_success: '🎉 ¡Gracias! Te contactaremos pronto.',
  cta_error: '❌ Ocurrió un error. Por favor, inténtalo de nuevo.',
  cta_privacy: 'Respetamos tu privacidad',
  
  // Footer
  footer_copyright: '© 2025 FaceTrue Red Social Global',
  footer_creator: 'Creado por Ben Nguyen',
  footer_powered: 'Constructor de sitios web',
  
  // Time
  time_hours_ago: 'hace horas',
  time_day_ago: 'hace día',
  
  // Children Page
  children_nav_features: 'Características',
  children_nav_safety: 'Seguridad',
  children_nav_activities: 'Actividades',
  children_back_home: 'Volver al inicio',
  
  children_hero_title: 'Bienvenido a',
  children_hero_subtitle: 'pequeños ángeles',
  children_hero_desc: '¡Un espacio seguro, divertido y educativo diseñado especialmente para niños!<br />Contenido 100% aprobado por padres con protección de IA.',
  children_explore_btn: 'Explorar características',
  children_safety_btn: 'Seguridad primero',
  
  children_features_title: 'Características divertidas y educativas',
  children_features_subtitle: 'Todo lo que los niños necesitan para aprender, jugar y crecer de forma segura',
  
  children_feature1_title: 'Contenido educativo',
  children_feature1_desc: 'Material de aprendizaje apropiado para la edad, cuestionarios divertidos y lecciones interactivas que hacen que la educación sea emocionante.',
  
  children_feature2_title: 'Juegos seguros',
  children_feature2_desc: 'Juegos cuidadosamente seleccionados que son divertidos, educativos y completamente seguros para que los niños disfruten.',
  
  children_feature3_title: 'Actividades creativas',
  children_feature3_desc: 'Dibujo, colorear, contar historias y otras actividades creativas para despertar la imaginación.',
  
  children_safety_title: 'La seguridad de su hijo es nuestra prioridad',
  children_safety_subtitle: 'Múltiples capas de protección para garantizar una experiencia sin preocupaciones',
  
  children_safety1_title: 'Filtrado de contenido por IA',
  children_safety1_desc: 'El monitoreo de IA 24/7 garantiza que solo el contenido apropiado llegue a los niños.',
  
  children_safety2_title: 'Controles parentales',
  children_safety2_desc: 'Los padres pueden monitorear la actividad y establecer límites de tiempo para un uso saludable.',
  
  children_safety3_title: 'Sin extraños',
  children_safety3_desc: 'Los niños solo pueden interactuar con amigos y familiares verificados.',
  
  children_activities_title: 'Explora actividades divertidas',
  children_activities_subtitle: '¡Haz clic en cualquier actividad para aprender más y comenzar a jugar!',
  
  // 8 Activities
  activity1_title: 'Dibujo y arte',
  activity1_desc: 'Crea obras de arte increíbles con herramientas digitales',
  
  activity2_title: 'Juegos educativos',
  activity2_desc: 'Aprende mientras te diviertes con juegos interactivos',
  
  activity3_title: 'Historias y lectura',
  activity3_desc: 'Explora mundos mágicos a través de historias',
  
  activity4_title: 'Música y canciones',
  activity4_desc: 'Descubre canciones y melodías divertidas',
  
  activity5_title: 'Fotos y videos',
  activity5_desc: 'Captura y comparte momentos especiales',
  
  activity6_title: 'Actividades grupales',
  activity6_desc: 'Juega y aprende junto con amigos',
  
  activity7_title: 'Desafíos y recompensas',
  activity7_desc: 'Completa desafíos divertidos y gana recompensas',
  
  activity8_title: 'Eventos especiales',
  activity8_desc: 'Únete a actividades estacionales emocionantes',
  
  children_footer_copyright: '© 2025 Comunidad infantil FaceTrue',
  children_footer_desc: 'Un espacio seguro y divertido para que los niños aprendan y crezcan',
  
  // Adults Page
  adults_nav_features: 'Características',
  adults_nav_community: 'Comunidad',
  adults_nav_benefits: 'Beneficios',
  adults_back_home: 'Volver al inicio',
  adults_hero_title: 'Conecta con',
  adults_hero_subtitle: 'Personas reales, historias reales',
  adults_hero_desc: 'Únete a una comunidad verificada de adultos que comparten experiencias auténticas,<br />construyen conexiones significativas y crecen juntos.',
  adults_explore_btn: 'Explorar características',
  adults_join_btn: 'Unirse a la comunidad',
  adults_features_title: 'Todo lo que necesitas para conectar',
  adults_features_subtitle: 'Networking profesional, compartir estilo de vida y conversaciones significativas',
  adults_feature1_title: 'Carrera y profesional',
  adults_feature1_desc: 'Conéctate con profesionales, comparte ideas de carrera y descubre oportunidades en tu campo.',
  adults_feature2_title: 'Estilo de vida e intereses',
  adults_feature2_desc: 'Comparte tus pasiones, hobbies y vida diaria con personas afines en todo el mundo.',
  adults_feature3_title: 'Conversaciones profundas',
  adults_feature3_desc: 'Participa en discusiones significativas sobre temas que te importan con usuarios verificados.',
  adults_community_title: 'Únete a comunidades globales',
  adults_community_subtitle: 'Conéctate con personas que comparten tus intereses y valores',
  adults_community_entrepreneurs: 'Emprendedores',
  adults_community_entrepreneurs_desc: 'Ideas de negocio y discusiones de startups',
  adults_community_health: 'Salud y bienestar',
  adults_community_health_desc: 'Fitness, nutrición y salud mental',
  adults_community_arts: 'Arte y cultura',
  adults_community_arts_desc: 'Expresión creativa e intercambio cultural',
  adults_community_travel: 'Viajes y aventura',
  adults_community_travel_desc: 'Comparte experiencias y consejos de viaje',
  adults_community_food: 'Comida y cocina',
  adults_community_food_desc: 'Recetas, restaurantes y artes culinarias',
  adults_community_technology: 'Tecnología',
  adults_community_technology_desc: 'Tendencias tecnológicas e innovación',
  adults_community_parenting: 'Crianza',
  adults_community_parenting_desc: 'Vida familiar y consejos de crianza',
  adults_community_education: 'Educación',
  adults_community_education_desc: 'Aprendizaje y desarrollo personal',
  adults_community_active: 'Comunidad activa',
  adults_community_join_btn: 'Unirse a la comunidad',
  adults_benefits_title: 'Por qué los adultos eligen FaceTrue',
  adults_benefits_subtitle: 'Una red social construida para conexiones auténticas de adultos',
  adults_benefit1_title: 'Identidades verificadas',
  adults_benefit1_desc: 'Conéctate con confianza sabiendo que todos son quienes dicen ser.',
  adults_benefit2_title: 'Sin toxicidad',
  adults_benefit2_desc: 'El filtrado de IA elimina el acoso, el discurso de odio y el contenido negativo.',
  adults_benefit3_title: 'Alcance global',
  adults_benefit3_desc: 'Conéctate con usuarios verificados en 119 países de todo el mundo.',
  adults_benefit4_title: 'Privacidad primero',
  adults_benefit4_desc: 'Tus datos están protegidos con medidas de seguridad de nivel empresarial.',
  adults_footer_copyright: '© 2025 Comunidad de adultos FaceTrue',
  adults_footer_desc: 'Conéctate auténticamente con adultos verificados en todo el mundo',
  
  // Seniors Page
  seniors_nav_features: 'Características',
  seniors_nav_health: 'Salud',
  seniors_nav_community: 'Comunidad',
  seniors_back_home: 'Volver al inicio',
  seniors_hero_title: 'Una comunidad',
  seniors_hero_subtitle: 'Construida para mayores',
  seniors_hero_desc: 'Comparte tu sabiduría, mantente conectado con tus seres queridos,<br />y disfruta de una comunidad en línea segura y de apoyo.',
  seniors_explore_btn: 'Explorar características',
  seniors_safety_btn: 'Unirse a la comunidad',
  seniors_features_title: 'Qué puedes hacer en FaceTrue',
  seniors_features_subtitle: 'Conecta, comparte y disfruta de interacciones significativas',
  seniors_feature1_title: 'Conexiones familiares',
  seniors_feature1_desc: 'Mantente conectado con miembros de la familia en todo el mundo. Comparte fotos, videos y actualizaciones de vida en un entorno seguro.',
  seniors_feature2_title: 'Comparte tu historia',
  seniors_feature2_desc: 'Comparte tus experiencias de vida, sabiduría y recuerdos con otros. Tus historias importan e inspiran.',
  seniors_feature3_title: 'Haz nuevos amigos',
  seniors_feature3_desc: 'Conéctate con personas que comparten tus intereses y hobbies. Construye amistades significativas.',
  seniors_feature4_title: 'Eventos locales',
  seniors_feature4_desc: 'Descubre y únete a eventos, actividades y reuniones de la comunidad local cerca de ti.',
  seniors_feature5_title: 'Aprende nuevas habilidades',
  seniors_feature5_desc: 'Accede a tutoriales, consejos y orientación sobre tecnología, hobbies y habilidades de la vida diaria.',
  seniors_feature6_title: 'Grupos de apoyo',
  seniors_feature6_desc: 'Únete a comunidades de apoyo para salud, bienestar y desafíos de la vida. No estás solo.',
  seniors_health_title: 'Recursos de salud y bienestar',
  seniors_health_subtitle: 'Mantente informado y saludable con información confiable',
  seniors_health1_title: 'Consejos de salud',
  seniors_health1_desc: 'Consejos de salud diarios, consejos de nutrición y orientación de ejercicio adaptados para mayores.',
  seniors_health2_title: 'Bienestar mental',
  seniors_health2_desc: 'Apoyo para la salud mental, prácticas de atención plena y manejo del estrés.',
  seniors_health3_title: 'Recordatorios de medicamentos',
  seniors_health3_desc: 'Establece recordatorios para medicamentos y citas de salud para mantenerte en el camino.',
  seniors_health4_title: 'Seguimiento de actividad',
  seniors_health4_desc: 'Rastrea tus actividades diarias, pasos y celebra tus hitos de bienestar.',
  seniors_community_title: 'Conéctate con tu comunidad',
  seniors_community_subtitle: 'Encuentra apoyo, comparte experiencias y haz conexiones significativas',
  seniors_community_family: 'Conexiones familiares',
  seniors_community_family_desc: 'Mantente cerca de los miembros de la familia',
  seniors_community_stories: 'Comparte tu historia',
  seniors_community_stories_desc: 'Experiencias de vida y sabiduría',
  seniors_community_friends: 'Haz nuevos amigos',
  seniors_community_friends_desc: 'Conéctate con compañeros en todo el mundo',
  seniors_community_events: 'Eventos locales',
  seniors_community_events_desc: 'Actividades comunitarias y reuniones',
  seniors_community_learning: 'Aprende nuevas habilidades',
  seniors_community_learning_desc: 'Nunca dejes de crecer y aprender',
  seniors_community_support: 'Grupos de apoyo',
  seniors_community_support_desc: 'Encuentra comprensión y aliento',
  seniors_community_join_btn: 'Unirse a la comunidad',
  seniors_benefits_title: 'Por qué los mayores aman FaceTrue',
  seniors_benefits_subtitle: 'Una red social que respeta y valora tu experiencia',
  seniors_benefit1_title: 'Sin estafas ni fraudes',
  seniors_benefit1_desc: 'Protección de IA contra estafadores y actividades fraudulentas.',
  seniors_benefit2_title: 'Texto grande y claro',
  seniors_benefit2_desc: 'Interfaz fácil de leer diseñada para una visualización cómoda.',
  seniors_benefit3_title: 'Soporte 24/7',
  seniors_benefit3_desc: 'La ayuda siempre está disponible cuando necesitas asistencia.',
  seniors_benefit4_title: 'Privacidad protegida',
  seniors_benefit4_desc: 'Tu información personal siempre se mantiene segura y privada.',
  seniors_benefit5_title: 'Comunidad respetuosa',
  seniors_benefit5_desc: 'Un ambiente positivo donde todos se tratan con respeto.',
  seniors_benefit6_title: 'Gratis para usar',
  seniors_benefit6_desc: 'Todas las funciones disponibles sin costo para ti.',
  seniors_footer_copyright: '© 2025 Comunidad de mayores FaceTrue',
  seniors_footer_desc: 'Un espacio seguro y de apoyo para que los mayores se conecten',
};

export default common;
